// react
import React, { useEffect } from "react";
// components
import Navbar from "../../components/general/Navbar";
import Footer from "../../components/general/Footer";
import Banner from "../../components/general/Banner";
import GeneralConditionsText from "./GeneralConditionsText";
import { GAPageView, initGA } from "../../index";

// component
function GeneralConditions() {
    // Google analytics
    useEffect(() => {
        initGA();
        GAPageView();
    }, []);

    // template
    return (
        <div className="website">
            <Navbar linkBack="/" />
            <Banner src="/images/public/contact/vop.png" position="bottom"/>
            <GeneralConditionsText />
            <Footer />
        </div>
    );
}

export default GeneralConditions;
